const EmptySpace = () => <span>&nbsp;&nbsp;</span>;

export { EmptySpace };
